import useMVU from "./mvu";
export { useMVU };
export default useMVU;
//# sourceMappingURL=index.js.map